import ThreeColumnRepository from "../ThreeColumnRepository"

export default class PricingThreeColumn extends ThreeColumnRepository {
    static schemaId = "pricing_threeColumn"

    constructor() {
        super(PricingThreeColumn.schemaId)
    }
}
